(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["njf-release-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.njfQuickAdd) return;
    window.njfQuickAdd = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function setOpen(qa, open) {
      var list = qa.querySelector('.njf-rel__qa-list');
      var opener = qa.querySelector('[data-njf-qa-open]');
      qa.classList.toggle('is-open', open);
      if (list) list.hidden = !open;
      if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && list && list.firstElementChild) list.firstElementChild.focus();
    }
    function closeAll(except) {
      document.querySelectorAll('.njf-rel__qa.is-open').forEach(function (qa) {
        if (qa !== except) setOpen(qa, false);
      });
    }

    /* Same add flow as the empty bag's ADD (njf-header-drawers): the theme morphs the drawer and count on cart:update */
    function add(button) {
      var qa = button.closest('[data-njf-qa]');
      var items = document.querySelector('cart-items-component');
      var sectionId = items && items.dataset.sectionId;
      qa.classList.add('is-loading');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }], sections: sectionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var dialog = document.querySelector('.cart-drawer__dialog');
            if (dialog) dialog.classList.toggle('cart-drawer--empty', cart.item_count === 0);
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'njf-quick-add',
                data: { itemCount: cart.item_count, source: 'njf-quick-add', variantId: button.dataset.variantId, sections: res.sections }
              }
            }));
            var drawer = document.querySelector('cart-drawer-component');
            if (!drawer) {
              window.location.href = root + 'cart';
            } else if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
              drawer.open();
            }
          });
        })
        .catch(function (err) {
          if (err && err.message) alert(err.message);
        })
        .then(function () {
          qa.classList.remove('is-loading');
          setOpen(qa, false);
        });
    }

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-njf-qa-add]');
      if (addBtn) {
        e.preventDefault();
        add(addBtn);
        return;
      }
      var opener = e.target.closest('[data-njf-qa-open]');
      if (opener) {
        e.preventDefault();
        var qa = opener.closest('[data-njf-qa]');
        closeAll(qa);
        setOpen(qa, !qa.classList.contains('is-open'));
        return;
      }
      if (!e.target.closest('[data-njf-qa]')) closeAll();
    });
    document.addEventListener('mouseleave', function (e) {
      if (!e.target.classList || !e.target.classList.contains('njf-rel__frame')) return;
      var qa = e.target.querySelector('.njf-rel__qa.is-open');
      if (qa) setOpen(qa, false);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
